import { useNavigate } from "react-router-dom";
import { FileText, MessageCircle } from "lucide-react";
import { METRICS, STATUS_LABEL } from "./labels";

export function MetricsGrid({ stats, testid = "c2g-metrics" }) {
  return (
    <div className="grid grid-cols-2 gap-2" data-testid={testid}>
      {METRICS.map(([k, l]) => (
        <div key={k} className="rounded-xl border border-[#27272A] bg-[#121215] p-3.5">
          <p className="tabular-nums text-2xl font-semibold text-[#FAF9F6]" data-testid={`${testid}-${k}`}>{stats[k]}</p>
          <p className="text-[12px] uppercase tracking-wider text-[#8A8E96]">{l}</p>
        </div>
      ))}
    </div>
  );
}

export function ReportEngine({ data, onNextWeek, onRepeat }) {
  const navigate = useNavigate();
  if (!data.available) {
    return (
      <div className="px-5 pt-6" data-testid="c2g-report-unavailable">
        <div className="rounded-2xl border border-[#27272A] bg-[#121215] p-5">
          <FileText size={20} className="text-[#D4AF37]" />
          <p className="a2g-read mt-2 text-base text-[#D4D4D8]">{data.message}</p>
          <button onClick={() => navigate("/oggi")} className="btn-outline-gold mt-4 rounded-full px-5 py-2 text-sm" data-testid="c2g-report-back">Torna a Oggi</button>
        </div>
      </div>
    );
  }
  const r = data.report;
  return (
    <div className="px-5 pb-8 pt-6" data-testid="c2g-report">
      <h1 className="font-serif-el text-3xl font-semibold text-[#FAF9F6]" data-testid="c2g-report-title">{r.title}</h1>
      <p className="a2g-read mt-3 text-base text-[#D4D4D8]" data-testid="c2g-report-intro">{r.intro}</p>
      <p className="a2g-read mt-2 text-base text-[#D4D4D8]" data-testid="c2g-report-summary">{r.summary}</p>
      <div className="mt-5"><MetricsGrid stats={r.metrics} testid="c2g-report-metrics" /></div>
      <ul className="mt-5 space-y-2" data-testid="c2g-report-days">
        {data.days.map((d) => (
          <li key={d.day} className="rounded-xl border border-[#27272A] bg-[#121215] p-3.5 text-sm" data-testid={`c2g-report-day-${d.day}`}>
            <p><span className="font-semibold text-[#E5C158]">Giorno {d.day}</span> · <span className="text-[#F4F4F5]">{d.title}</span></p>
            <p className="mt-1 text-[#B4B4BC]">{d.skipped ? "Giorno saltato" : d.step ? `${d.active_step?.mode !== "full" && d.active_step ? d.active_step.text : d.step} · ${STATUS_LABEL[d.status]}` : "Nessun passo scelto"}{d.restart ? " · ripresa dopo una pausa" : ""}</p>
          </li>
        ))}
      </ul>
      <div className="mt-5 rounded-2xl border border-[#D4AF37]/30 bg-[#D4AF37]/5 p-5 space-y-3">
        <p className="a2g-read text-base text-[#F4F4F5]" data-testid="c2g-report-reflection">{r.reflectionPrompt}</p>
        <p className="a2g-read text-base text-[#D4D4D8]" data-testid="c2g-report-next">{r.nextStepPrompt}</p>
      </div>
      <div className="mt-5 flex flex-col gap-2">
        {data.next_week_available && <button onClick={onNextWeek} data-testid="summary-next-week" className="btn-gold rounded-full px-5 py-3 text-sm font-semibold uppercase tracking-wide">Continua: Settimana {data.week + 1}</button>}
        <button onClick={onRepeat} data-testid="summary-repeat-week" className="rounded-full border border-[#3F3F46] px-5 py-3 text-sm font-semibold text-[#E4E4E7]">Ripeti questa settimana</button>
        <button onClick={() => navigate("/scegli")} data-testid="summary-other-path" className="rounded-full border border-[#3F3F46] px-5 py-3 text-sm font-semibold text-[#E4E4E7]">Approfondisci un'altra area</button>
        <button onClick={() => navigate("/coach")} data-testid="summary-coach" className="flex items-center justify-center gap-2 rounded-full border border-[#3F3F46] px-5 py-3 text-sm font-semibold text-[#E4E4E7]"><MessageCircle size={16} /> Parlane con Coach Mino</button>
      </div>
    </div>
  );
}
